import { isArray, merge, omit } from 'lodash';
import mutationTypes from './mutationTypes';
import results from '@nsftx/games-sdk-js/src/api/results';
import statistics from '@nsftx/games-sdk-js/src/api/statistics';
import auth from '@nsftx/games-sdk-js/src/api/auth';

const getEventValue = (bet) => {
  if (bet.outcome.drawn && !isArray(bet.outcome.drawn)) {
    const value = [];
    value.push(bet.outcome.drawn);
    return value;
  }
  if (bet.outcome.drawn && isArray(bet.outcome.drawn)) {
    return bet.outcome.drawn;
  }
  return bet.eventValue || [];
};

export default {
  setConfig({ commit }, config) {
    commit(mutationTypes.SET_CONFIG, config);
  },
  getResults({ state, dispatch }) {
    const count = 11;
    results.getResults(state.config, null, count).then((resultsResponse) => {
      dispatch('setResults', resultsResponse.data);
    });
  },
  getStats({ state, dispatch }) {
    statistics.getStatistics(state.config).then((stats) => {
      dispatch('setStats', stats.data);
      dispatch('updateMostLeastDrawn', stats.data);
    });
  },
  setResults({ commit }, data) {
    commit(mutationTypes.SET_PRODUCT_RESULTS, data);
  },
  setStats({ commit }, data) {
    commit(mutationTypes.SET_PRODUCT_STATS, data);
  },
  setUserData({ dispatch }, payload) {
    let user = {};
    if (payload.auth) {
      user = {
        auth: omit(payload.auth, 'user'),
        profile: payload.auth.user,
      };
    } else {
      user = {
        auth: {
          token: payload.token,
        },
        profile: omit(payload, ['token', 'tokenType']),
      };
    }
    dispatch('user/updateUser', user, { root: true });
  },
  setUserBalance({ state, dispatch }, payload) {
    const divider = state.config?.ui?.config?.balanceDivider;
    const balance = divider ? payload / divider : payload;
    dispatch('user/setUserBalance', balance, { root: true });
  },
  updateBalls({ commit }, data) {
    commit(mutationTypes.UPDATE_BALLS, data);
  },
  setBalls({ commit }, data) {
    commit(mutationTypes.SET_BALLS, data);
  },
  setActiveBettingTab({ commit }, tab) {
    commit(mutationTypes.SET_ACTIVE_BETTING_TAB, tab);
  },
  setColorBet({ commit }, bet) {
    commit(mutationTypes.SET_COLOR_BET, bet);
  },
  resetBalls({ commit }) {
    commit(mutationTypes.RESET_BALLS);
  },
  resetColorBet({ commit }) {
    commit(mutationTypes.RESET_COLOR_BET);
  },
  updateMostLeastDrawn({ commit }, data) {
    commit(mutationTypes.UPDATE_MOST_LEAST_DRAWN, data);
  },
  updateRound({ commit }, round) {
    commit(mutationTypes.UPDATE_ROUND, round);
  },
  setDrawnColor({ commit }, data) {
    commit(mutationTypes.SET_DRAWN_COLOR, data);
  },
  resetColors({ commit }) {
    commit(mutationTypes.RESET_COLORS);
  },
  addBettingTab({ commit }, tab) {
    commit(mutationTypes.ADD_BETTING_TAB, tab);
  },
  formatPlayerTickets({ getters }, payload) {
    const getBetName = (bet) => {
      const keyname = bet?.bet?.titleKeyName;
      return keyname ? getters.translations[keyname] : bet?.bet?.title;
    };
    const getOutcomeName = (bet) => {
      const keyname = bet?.outcome?.titleKeyName;
      return keyname ? getters.translations[keyname] : bet?.outcome?.title;
    };
    return payload?.map((ticket) => {
      let bets = [];
      bets = ticket.bets.map((bet) => ({
        id: bet.id,
        status: bet.status,
        round: bet.eventId,
        market: `${getBetName(bet)} ${bet.ballPositions}`,
        outcome: getOutcomeName(bet),
        drawn: bet.outcome.drawn,
        //  eventValue: bet.outcome.drawn ?? [],
        value: bet.value,
        stake: bet.amount,
        type: bet.type,
        odd: Number(bet.odd),
        eventValue: getEventValue(bet),
      }));

      return {
        id: ticket.id,
        payout: ticket.payout,
        payin: ticket.payin,
        payinTax: ticket.payinTax,
        payoutTax: ticket.payoutTax,
        superBonus: ticket.superBonus,
        createdAt: ticket.createdAt,
        status: ticket.status,
        maxPossibleWin: ticket.maxPossibleWin,
        providerBetslipId: ticket.requestUuid,
        isFreeBet: ticket.bonuses,
        bets,
      };
    });
  },
  disableAllBetting({ state, commit }, isDisabled) {
    const bettingDisabled = !state.pernamentBettingDisabled ? isDisabled : true;
    commit(mutationTypes.ALL_BETTING_DISABLED, bettingDisabled);
  },
  setCanceledTicket({ commit }, ticket) {
    commit(mutationTypes.SET_CANCELED_TICKET, ticket);
  },
  setPayinDisabledFromSocket({ commit }, isDisabled) {
    commit(mutationTypes.SET_PAYIN_DISABLED_FROM_SOCKET, isDisabled);
  },
  setLastSelectedBet({ commit }, bet) {
    commit(mutationTypes.SET_LAST_SELECTED_BET, bet);
  },
  setHideLoader({ commit }, hide) {
    commit(mutationTypes.SET_HIDE_LOADER, hide);
  },
  async getPlayer({ getters, dispatch }, { config, token }) {
    try {
      const player = await auth.authenticate(config, token);
      const isLoggedIn = !!player.uuid;
      const userData = {
        auth: {
          token: player.auth.token,
          tpToken: player.auth.thirdPartyToken || null,
        },
        profile: merge({
          balance: player.balance,
          balanceTotal: player.balance,
          logged: isLoggedIn,
          id: player.uuid,
        }),
      };
      if (isLoggedIn) {
        dispatch('user/updateUser', userData);
        dispatch('setUserBalance', player.balance);
      }
    } catch (error) {
      const message = {
        message: getters.translations.general_player_login,
        notificationTimeout: 5000,
      };
      dispatch('notifications/setNotification', message);
    }
  },
  setDrawnBallsStateActive({ commit }, isActive) {
    commit(mutationTypes.SET_DRAWN_BALLS_STATE_ACTIVE, isActive);
  },
  setTicketPayinInProg({ commit }, isInProg) {
    commit(mutationTypes.SET_TICKET_PAYIN_IN_PROG, isInProg);
  },
  updateConfig({ commit }, property) {
    commit(mutationTypes.UPDATE_CONFIG, property);
  },
  setNextGenConfig({ commit }, config) {
    commit(mutationTypes.SET_NEXT_GEN_CONFIG, config);
  },
  updateConfigWithNextGenConfig({ state, commit }) {
    const { nextGenConfig } = state;
    if (!nextGenConfig) return;
    Object.entries(nextGenConfig).forEach(([key, value]) => {
      commit(mutationTypes.UPDATE_CONFIG, { [key]: value });
    });
  },
  setPernamentBettingDisabled({ commit }, pernamentBettingDisabled) {
    commit(mutationTypes.SET_PERNAMENT_BETTING_DISABLED, pernamentBettingDisabled);
  },
  toggleFreeBetModal({ commit }, show) {
    commit(mutationTypes.TOGGLE_FREE_BET_MODAL, show);
  },
  toggleFreeBetExpiredModal({ commit }, show) {
    commit(mutationTypes.TOGGLE_FREE_BET_EXPIRED_MODAL, show);
  },
  setLastDrawnBallId({ commit }, ball) {
    commit(mutationTypes.SET_LAST_DRAWN_BALL_ID, ball);
  },
  setNextGenStandaloneIntegration({ commit }, standaloneIntegration) {
    commit(mutationTypes.SET_NEXTGEN_STANDALONE_INTEGRATION, standaloneIntegration);
  },
  setOdds({ commit }, odds) {
    commit(mutationTypes.SET_ODDS, odds);
  },
  clearDrawnBalls({ commit }, drawnBalls) {
    commit(mutationTypes.CLEAR_DRAWN_BALLS, drawnBalls);
  },
  addDrawnBall({ commit }, ball) {
    commit(mutationTypes.ADD_DRAWN_BALL, ball);
  },
  setLessThanSixBallsLeft({ commit }, value) {
    commit(mutationTypes.SET_LESS_THAN_SIX_BALLS_LEFT, value);
  },
  setBettingTabProperties({ commit }, payload) {
    commit(mutationTypes.SET_BETTING_TAB_PROPERTIES, payload);
  },
  setBallProperties({ commit }, payload) {
    commit(mutationTypes.SET_BALL_PROPERTIES, payload);
  },
  resetRemainingBalls({ commit }) {
    commit(mutationTypes.RESET_REMAINING_BALLS);
  },
  updateRemainingBalls({ commit }, ball) {
    commit(mutationTypes.UPDATE_REMAINING_BALLS, ball);
  },
};
